import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ImagePreloadDirectiveModule } from 'src/app/directives/index';

import { LogoutTabComponent } from './logout-tab/logout-tab.component';
import { MainHeaderComponent } from './main-header.component';
import { NotificationDropdownComponent } from './notification-dropdown/notification-dropdown.component';
import { NotificationDropdownComponentModule } from './notification-dropdown/notification-dropdown.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ImagePreloadDirectiveModule,
		NotificationDropdownComponentModule,
	],
	declarations: [MainHeaderComponent, LogoutTabComponent],
	exports: [MainHeaderComponent],
})
export class MainHeaderComponentModule {}
